export const RegionDepth = {
  REGION: 1, // 시/도
  DISTRICT: 2, // 시/군/구
} as const;

type RegionDepthType = (typeof RegionDepth)[keyof typeof RegionDepth];

// 시·도 이름의 축약 표기. 주소는 '경기', '강원특별자치도'처럼 표기가 섞여 들어온다.
const SHORT_REGION_NAMES: Record<string, string> = {
  경기도: '경기',
  강원도: '강원',
  강원특별자치도: '강원',
  충청북도: '충북',
  충청남도: '충남',
  전라북도: '전북',
  전북특별자치도: '전북',
  전라남도: '전남',
  전남광주통합특별시: '전남',
  경상북도: '경북',
  경상남도: '경남',
  서울특별시: '서울',
  부산광역시: '부산',
  대구광역시: '대구',
  인천광역시: '인천',
  광주광역시: '광주',
  대전광역시: '대전',
  울산광역시: '울산',
  세종특별자치시: '세종',
  제주특별자치도: '제주',
};

const formatRegionName = (regionName: string): string => {
  return SHORT_REGION_NAMES[regionName] ?? '';
};

export const getRegionByDepth = (address: string, depth: RegionDepthType): string => {
  if (!address) {
    return '';
  }

  const addressParts = address.split(' ');
  const formattedRegion = formatRegionName(addressParts[0]);

  if (depth === RegionDepth.REGION) {
    return formattedRegion || addressParts[0];
  }

  const districtParts = addressParts.slice(0, depth);
  if (formattedRegion) {
    districtParts[0] = formattedRegion;
  }

  return districtParts.join(' ');
};

export const getShortRegionAddress = (address: string): string => {
  if (!address) {
    return '';
  }

  const addressParts = address.split(' ');
  const formattedRegion = formatRegionName(addressParts[0]);

  const shortRegionName = formattedRegion || addressParts[0];

  const result = [shortRegionName, ...addressParts.slice(1)].join(' ');

  return result;
};
